import moment from 'moment'

const HttpUtil = {
	install(app) {
		const buildHeaders = function(ctx, options) {
			const user = ctx.$store.state.loggedInUser
			const client = ctx.$store.state.selectedClient
			const apps = ctx.$store.state.spApplications ?? []
			const selectedApp = ctx.$store.state.selectedComponent

			let appId = selectedApp?.sys?.id ?? ''

			// Get Application Id for Service Designer if the current selectedComponent = 'Manage Services'
			if (selectedApp?.fields?.title?.en === 'Manage Services') {
				appId = apps.find(a => a.fields?.title?.en === 'Service Designer')?.sys?.id
			}

			// Get Application Id for Business Profile if the current selectedComponent = 'Service Providers'
			if (selectedApp?.fields?.title?.en === 'Service Providers') {
				appId = apps.find(a => a.fields?.title?.en === 'Business Profile')?.sys?.id
			}

			return {
				'Authorization': 'Bearer ' + (options?.token ?? user?.kc_token),
				'Accept': '*/*',
				'mys-user-id': user?.sys?.id ?? '',
				'mys-user-type': user?.fields?.type?.de ?? '',
				'mys-client-id': client?.sys?.id ?? '',
				'mys-client-organization-id': client?.fields?.organizationId?.de ?? '',
				'mys-client-freddy-assistant-id': client?.fields?.freddyAssistantId?.de ?? '',
				'mys-app-id': appId,
				'mys-tx-id': moment().valueOf()
			}
		}

		app.config.globalProperties.$httpFetch = async function(method, url, body, options) {
			try {
				if (url.indexOf('/') == 0 && url.indexOf('/api') == -1) url = '/api' + url
				let response = await fetch(url, {
					method: method,
					headers: {
						...buildHeaders(this, options),
						'Accept': 'application/json, text/plain, */*',
						'Content-Type': 'application/json',
					},
					body:
						body === undefined ? body :
						typeof body == 'string' ? body :
						JSON.stringify(body),
				})
	
				if (response.status === 204) return null
				if ((response.status === 401 || response.status === 403)
					// this is a hack to avoid logout on metis 401 errors
					&& url.indexOf('peak/skidata-client-config') < 0
					// do not logout on reset-password failure (wrong current password) - show validation error instead
					&& url.indexOf('reset-password') < 0
				) {
					console.warn('request to', url, 'failed with', response.status, '-> showLogin')
					this.$root.app.showLogin()
				}
	
				let result
				try {
					result = await response.clone().json()
				}
				catch (e) {
					// TODO: certain bodies may be allowed, like OK
					if (response.status === 200) {
						result = {}
					} else {
						throw new Error('could not read response: ' + method + ' ' + url, e)
					}
				}
	
				if (result.isError && result.status >= 400) throw result
				if (response.status >= 400) throw await response.text()
				return result
			}
			catch (e) {
				let errorObject = typeof e === 'string' ? (() => { try { return JSON.parse(e) } catch (_) { return { message: e } } })() : e
				
				if (errorObject?.status === 401 && this.$route.path !== '/'
					// do not logout on reset-password failure - show validation error in dialog instead
					&& (typeof url === 'string' && url.indexOf('reset-password') < 0)
				) {
					// TODO: refresh the token instead?
					// TODO: make a message instead with a logot button!
					//       otherwise a programming error on the api may lead to a logout
					//       so the user still has the screen to make a grab or sth.
					console.warn('request to', url, 'failed with', response.status, '-> showLogin')
					this.$root.app.showLogin()
					return
				}
				// TODO: handle other codes specifically as well?
				// 403 -> you are not allowed here
				throw errorObject
			}
		}

		app.config.globalProperties.$httpFetchBlob = async function(method, url, options) {
			if (url.indexOf('/') == 0 && url.indexOf('/api') == -1) url = '/api' + url

			const response = await fetch(url, {
				method: method,
				headers: buildHeaders(this, options)
			})

			if (!response.ok) {
				throw new Error('blob request failed with status ' + response.status)
			}

			return await response.blob()
		}

		app.config.globalProperties.$httpGet = async function(url, query, options) {
			if (!query) query = {}
			url += url.indexOf('?') < 0 ? '?' : '&'
			return await this.$httpFetch('GET', url + new URLSearchParams(query).toString(), undefined, options)
		}

		app.config.globalProperties.$httpPut = async function(url, object, options) {
			return await this.$httpFetch('PUT', url, object, options)
		}

		app.config.globalProperties.$httpPost = async function(url, object, options) {
			return await this.$httpFetch('POST', url, object, options)
		}

		app.config.globalProperties.$httpDelete = async function(url, object, options) {
			return await this.$httpFetch('DELETE', url, object, options)
		}

		app.config.globalProperties.$httpGetBlob = async function(url, query, options) {
			if (!query) query = {}
			url += url.indexOf('?') < 0 ? '?' : '&'
			return await this.$httpFetchBlob('GET', url + new URLSearchParams(query).toString(), options)
		}
	},
}

export default HttpUtil